/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketStatusResponseItem } from '../../models/ticket-status-response-item';

export interface TicketStatusControllerRemove$Params {

/**
 * Ticket status ID
 */
  id: number;
}

export function ticketStatusControllerRemove(http: HttpClient, rootUrl: string, params: TicketStatusControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusResponseItem;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketStatusControllerRemove.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketStatusResponseItem;
      }>;
    })
  );
}

ticketStatusControllerRemove.PATH = '/ticket-status/{id}';
